<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      letter: state => state.letter,
    }),
  }
}
</script>

<template>
  <div class="footer-safe">
    <div class="footer-safe-item">
      <div class="footer-safe-icon first"></div>
      <div class="footer-safe-text">
        <p>
          {{ letter.footerSafeTitle1 }} <br/>
          <span class="footer-safe-text__content">
          {{ letter.footerSafeContent1 }}
          </span>
        </p>
      </div>
    </div>
    <div class="footer-safe-item">
      <div class="footer-safe-icon second"></div>
      <div class="footer-safe-text">
        <p>
          {{ letter.footerSafeTitle2 }} <br/>
          <span class="footer-safe-text__content">
          {{ letter.footerSafeContent2 }}
          </span>
        </p>
      </div>
    </div>
    <div class="footer-safe-item">
      <div class="footer-safe-icon third"></div>
      <div class="footer-safe-text">
        <p>
          {{ letter.footerSafeTitle3 }} <br/>
          <span class="footer-safe-text__content">
          {{ letter.footerSafeContent3 }}
          </span>
        </p>
      </div>
    </div>
    <div class="footer-safe-item">
      <div class="footer-safe-icon forth"></div>
      <div class="footer-safe-text">
        <p>
          {{ letter.footerSafeTitle4 }} <br/>
          <span class="footer-safe-text__content">
          {{ letter.footerSafeContent4 }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@assets/scss/officialStore/_dimen.scss';
.footer-safe {
  background: #0E111A;
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  gap: 0;
  padding: 20px 60px;
  box-sizing: border-box;
  margin-bottom: 130px;
  flex-wrap: wrap;

  &-item {
    display: flex;
    width: 50%;
    padding: 15px;
    gap: 20px;
    box-sizing: border-box;

    p {
      font-size: 32px;

      .footer-safe-text__content {
        font-size: 20px;
      }
    }
  }

  &-icon {
    width: 53px;
    height: 53px !important;
    background-size: contain;
    flex-shrink: 0;

    &.first {
      width: 50px !important;
      height: 56px !important;
      @psetbg ('footer-safe-icon-1.png');
    }

    &.second {
      width: 48px !important;
      height: 49px !important;
      @psetbg ('footer-safe-icon-2.png');
    }

    &.third {
      width: 53px !important;
      @psetbg ('footer-safe-icon-3.png');
    }

    &.forth {
      width: 58px !important;
      height: 58px !important;
      @psetbg ('footer-safe-icon-4.png');
    }
  }

  &-text {
    text-align: left;
    color: #fff;
    font-size: 24px;

    &__content {
      color: #bfbebe;
      font-size: 16px;
    }
  }
}

@media screen and (orientation: landscape) {
  .footer-safe {
    gap: 50px;
    padding: 20px;
    flex-wrap: nowrap;
    margin-bottom: 130px;


    &-item {
      width: fit-content;
    }

    &-icon {
      width: 49px;
      height: 49px !important;
      background-size: contain;

      &.first {
        width: 44px !important;
        @psetbg ('footer-safe-icon-1.png');
      }

      &.second {
        width: 49px !important;
        @psetbg ('footer-safe-icon-2.png');
      }

      &.third {
        width: 49px !important;
        @psetbg ('footer-safe-icon-3.png');
      }

      &.forth {
        width: 49px !important;
        @psetbg ('footer-safe-icon-4.png');
      }
    }
  }
}
</style>
